import React, { useState } from 'react';
import ReactHtmlParser from '@orrisroot/react-html-parser';

import infoIconSvg from 'assets/images/button/info-blue.svg';
import PopupModal from 'components/PopupModal/PopupModal';
import useViewport from 'utils/useViewportHelper';

interface Props {
  header: string;
  body: string;
  modal?: {
    link?: string;
    text?: string;
  };
}

const CheckedList = ({ header, body, modal }: Props) => {
  const [toggleInfo, setToggleInfo] = useState(false);

  const { isMobile } = useViewport();

  return (
    <div className="container">
      <div className="row">
        <div className={`col-1 fs-3 ${isMobile && 'p-0'}`}>
          <i className="fas fa-check-circle rac-checkbox" />
        </div>
        <div className={`col ${!isMobile && 'p-0 py-1'}`}>
          <h5>{header}</h5>
          {ReactHtmlParser(body)}
          {modal?.link && (
            <p>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
              <img src={infoIconSvg} alt="info" height="16" width="16" className="m-0 p-0" /><a onClick={() => setToggleInfo(true)} className="mx-2 text-link">{modal?.link}</a>
              {toggleInfo && (
                <PopupModal
                  resultTitle={ReactHtmlParser(modal?.link)}
                  resultText={ReactHtmlParser(modal?.text ?? '')}
                  action={() => setToggleInfo(false)}
                  displayDialogInMiddle
                  innerCloseButton
                />
              )}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckedList;
